import { useLingui } from "@lingui/react/macro";
import { Alert, List, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocsContent } from "@/components/docs/DocsContent.tsx";

export const Route = createFileRoute("/docs/data-use/permitted-use")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`Authorisation and permitted use`}</Title>
      <Text>
        {t`Access to REALity does not automatically mean that all available information may be used for all purposes.`}
      </Text>

      <DocHeading
        order={2}
        size="h3"
      >{t`Access control in REALity`}</DocHeading>
      <List withPadding>
        <List.Item>{t`User authentication.`}</List.Item>
        <List.Item>{t`Role-based access.`}</List.Item>
        <List.Item>{t`Assignment-based access.`}</List.Item>
        <List.Item>{t`Dataset-specific permissions.`}</List.Item>
        <List.Item>{t`Purpose-related controls.`}</List.Item>
        <List.Item>{t`Restrictions on sensitive information.`}</List.Item>
        <List.Item>{t`Monitoring of data requests.`}</List.Item>
      </List>

      <DocHeading order={2} size="h3">{t`Before using data`}</DocHeading>
      <Text>{t`Before using data, make sure that:`}</Text>
      <List type="ordered" withPadding>
        <List.Item>{t`You are authorised to access the data.`}</List.Item>
        <List.Item>{t`The request is made for a valid Sweco assignment.`}</List.Item>
        <List.Item>{t`The customer and assignment permit the use.`}</List.Item>
        <List.Item>{t`The dataset is suitable for the intended purpose.`}</List.Item>
        <List.Item>{t`You follow Lantmäteriet’s and Sweco’s terms.`}</List.Item>
        <List.Item>{t`You do not redistribute data unless this is permitted.`}</List.Item>
      </List>

      <DocHeading order={2} size="h3">{t`Sensitive data`}</DocHeading>
      <Alert variant="light" color="yellow">
        {t`Sensitive data, including personal or ownership information, must be handled according to applicable legislation, licensing conditions and Sweco policies.`}
      </Alert>
    </DocsContent>
  );
}
